import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";

export const Nav = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [sosOpen, setSosOpen] = useState(false);
    const navRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navRef.current && !navRef.current.contains(event.target)) {
                setMenuOpen(false);
                setSosOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleNavItemClick = () => setMenuOpen(false);

    const handlePhoneRequestClick = () => {
        setSosOpen(false);
        navigate("/phone-request-page");
    };

    return (
        <nav className="nav" ref={navRef}>
            <div className="navbar">
                {/* бургер меню */}
                <div className="burger" onClick={() => setMenuOpen(!menuOpen)}>
                    <div className="line" />
                    <div className="line" />
                    <div className="line" />
                </div>

                {/* ссылки */}
                <div className={`nav-links ${menuOpen ? "open" : ""}`}>
                    <div className="nav-item underline" onClick={handleNavItemClick}>
                        КАСКО
                    </div>

                    <div className="nav-item coming-wrapper" onClick={handleNavItemClick}>
                        ОСАГО
                        <span className="coming">СКОРО</span>
                    </div>

                    <div className="nav-item coming-wrapper" onClick={handleNavItemClick}>
                        TRAVEL
                        <span className="coming">СКОРО</span>
                    </div>

                    <div className="nav-item coming-wrapper" onClick={handleNavItemClick}>
                        НЕСЧАСТКА
                        <span className="coming">СКОРО</span>
                    </div>

                    <div className="nav-item" onClick={handleNavItemClick}>
                        ДОРОЖНАЯ КАРТА
                    </div>
                </div>

                {/* SOS + выпадающий список */}
                <div className="sos-wrapper">
                    <div className="sos" onClick={() => setSosOpen(!sosOpen)}>
                        <div className="sos-left">SOS</div>
                        <div className="sos-text">Страховой случай</div>
                        <img
                            className={`sos-icon ${sosOpen ? "open" : ""}`}
                            alt="arrow"
                            src="https://c.animaapp.com/mdgpppf7nmySsB/img/vector.svg"
                        />
                    </div>

                    <div className={`sos-dropdown ${sosOpen ? "show" : ""}`}>
                        <div className="dropdown-item" onClick={handlePhoneRequestClick}>
                            <span className="dropdown-icon">📞</span>
                            <div className="dropdown-text">
                                <h5>Оставить заявку на звонок</h5>
                                <p>Мы перезвоним в течение 5 минут</p>
                            </div>
                        </div>

                        <div
                            className="dropdown-item"
                            onClick={() => window.open("/files/europrotokol_uz.pdf", "_blank")}
                        >
                            <span className="dropdown-icon">📄</span>
                            <div className="dropdown-text">
                                <h5>Скачать бланк европротокола</h5>
                                <p>PDF файл для печати и заполнения</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
};
